import { registerFlag } from './flag-registry';

export type FlagDefinitionOptions = {
  key: string;
  title: string;
  description: string;
  defaultValue: boolean;
};

export type FlagDefinition = Readonly<FlagDefinitionOptions>;

export function flag(options: FlagDefinitionOptions): FlagDefinition {
  const definition: FlagDefinition = Object.freeze({ ...options });
  registerFlag(definition);
  return definition;
}
